// extracted by mini-css-extract-plugin
module.exports = {"about":"About_about___5qCd","title":"About_title__3L94o","body":"About_body__16yCe"};